// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bondId: __t.u64().primaryKey().name("bond_id"),
  civ: __t.string(),
  holderId: __t.u64().name("holder_id"),
  principal: __t.i64(),
  status: __t.string(),
  issuedAt: __t.timestamp().name("issued_at"),
  dueEpoch: __t.i64().name("due_epoch"),
});
